export default __webpack_public_path__ + "static/media/palasLogo.a200de2f.png";